import React from "react";
import { useSafariPadding } from "@/hooks/useSafaryPadding";

interface SettingsModalContentProps {
  handleEnableNotifications: () => void;
  navigateToProfile: () => void;
  onAbout: () => void;
  isPushNotificationEnabled: boolean;
  navigateToAstrologChanel: () => void;
  navigateToDeveloperChanel: () => void;
}

const SettingsModalContent: React.FC<SettingsModalContentProps> = ({
  handleEnableNotifications,
  navigateToProfile,
  onAbout,
  isPushNotificationEnabled,
  navigateToAstrologChanel,
  navigateToDeveloperChanel,
}) => {

  const paddingBottom = useSafariPadding();

  return (
    <div className="w-full max-w-md p-0 text-white h-full"
    
    style={{
      paddingBottom: `max(calc(env(safe-area-inset-bottom, 0px)), ${paddingBottom}px)`,
    }}
    >
      <div className="text-lg font-bold px-6 pt-6 pb-4">Настройки</div>
      <div className="flex flex-col divide-y divide-gray-500/30">
        <button
          className="text-left px-6 py-3 text-base font-normal"
          onClick={navigateToProfile}
        >
          Профиль
        </button>
        <button
          className="text-left px-6 py-3 text-base font-normal"
          onClick={onAbout}
        >
          О приложении
        </button>
        <button
          className="text-left px-6 py-3 text-base font-normal"
          onClick={navigateToAstrologChanel}
        >
          Посетить Telegram астролога
        </button>
        <button
          className="text-left px-6 py-3 text-base font-normal"
          onClick={navigateToDeveloperChanel}
        >
          Написать разработчикам
        </button>
        <div className="flex items-center justify-between px-6 py-3">
          <span className="text-base font-normal">Пуш-уведомления</span>
          <label className="inline-flex relative items-center cursor-pointer">
            <input
              type="checkbox"
              checked={isPushNotificationEnabled}
              onChange={() => handleEnableNotifications()}
              className="sr-only peer"
            />
            <div className="w-11 h-6 bg-gray-600 peer-focus:outline-none rounded-full peer peer-checked:bg-cyan-600 transition-all"></div>
            <div
              className={`absolute left-0.5 top-0.5 w-5 h-5 bg-white rounded-full shadow-md transition-all ${
                isPushNotificationEnabled ? "translate-x-5" : ""
              }`}
            ></div>
          </label>
        </div>
      </div>
    </div>
  );
};

export default SettingsModalContent;
